import { useAppDispatch, useAppSelector } from "features/hooks";
import { setDataHouseModelGoals } from "features/houseModel";
import { THouseModelGoals } from "features/houseModel/houseModel.types";
import { RootState } from "features/store";
import { ChangeEvent, FC, FormEvent, useState } from "react";
import styles from "../Forms.module.scss";

const HouseModelGoalsForm: FC = () => {
  const dispatch = useAppDispatch();
  const data: THouseModelGoals = useAppSelector(
    (state: RootState) => state.houseModel.data.goals
  );
  const [value, setValue] = useState<THouseModelGoals>({
    first: data?.first || "",
    second: data?.second || "",
    third: data?.third || "",
    fourth: data?.fourth || "",
    last: data?.last || "",
  });

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setValue({
      ...value,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    dispatch(setDataHouseModelGoals(value));
    alert("Đã lưu!");
  };

  return (
    <div className={styles.contentWrap}>
      <div className={styles.container}>
        <h3 className={styles.title}>
          <span className={styles.strong}>5 cấp</span> mục tiêu trung gian
        </h3>
        <p className={styles.subtitle}>
          Mỗi cấp có những thách thức và lợi ích riêng
        </p>
        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.formControl}>
            <label className={styles.label}>Mục tiêu cấp 1</label>
            <textarea
              className={styles.input}
              name="first"
              onChange={handleChange}
              rows={10}
            >
              {value.first}
            </textarea>
          </div>
          <div className={styles.formControl}>
            <label className={styles.label}>Mục tiêu cấp 2</label>
            <textarea
              className={styles.input}
              name="second"
              onChange={handleChange}
              rows={8}
            >
              {value.second}
            </textarea>
          </div>
          <div className={styles.formControl}>
            <label className={styles.label}>Mục tiêu cấp 3</label>
            <textarea
              className={styles.input}
              name="third"
              onChange={handleChange}
              rows={6}
            >
              {value.third}
            </textarea>
          </div>
          <div className={styles.formControl}>
            <label className={styles.label}>Mục tiêu cấp 4</label>
            <textarea
              className={styles.input}
              name="fourth"
              onChange={handleChange}
              rows={3}
            >
              {value.fourth}
            </textarea>
          </div>
          <div className={styles.formControl}>
            <label className={styles.label}>Mục tiêu cuối cùng</label>
            <textarea
              className={styles.input}
              name="last"
              onChange={handleChange}
              rows={1}
            >
              {value.last}
            </textarea>
          </div>
          <button type="submit" className={styles.btn}>
            Lưu lại
          </button>
        </form>
      </div>
    </div>
  );
};

export default HouseModelGoalsForm;
